import {
    NEW_OD_PRODUCTION_SERVER_RESERVATIONS_PAGE_URL,
    NEW_OD_PRODUCTION_SERVER_RESTAURANT_PAGE_URL,
    NEW_OD_TEST_SERVER_RESERVATIONS_PAGE_URL,
    NEW_OD_TEST_SERVER_RESTAURANT_PAGE_URL
} from '../gconfig';
import { LOCAL_STORAGE_KEYS } from './local-storage.constant';
import { LocalStorageManager } from './tool-local-storage';

function getNewOdBaseUrl(restaurantPath: 'restaurant-page' | 'reservations'): string {
    const isProductionOd = process.env.REACT_APP_BASE_URL === 'https://ordelivery-public-api.evophotic.com';
    if (restaurantPath === 'reservations') {
        return isProductionOd ? NEW_OD_PRODUCTION_SERVER_RESERVATIONS_PAGE_URL : NEW_OD_TEST_SERVER_RESERVATIONS_PAGE_URL;
    }
    return isProductionOd ? NEW_OD_PRODUCTION_SERVER_RESTAURANT_PAGE_URL : NEW_OD_TEST_SERVER_RESTAURANT_PAGE_URL;
}

function openNewOdPage(base: string, restaurantStringId: string): void {
    const rwgToken = LocalStorageManager.getLocalStorage(LOCAL_STORAGE_KEYS.RWG_TOKEN);
    let url = base + encodeURIComponent(restaurantStringId);
    if (rwgToken) {
        url += `&rwg_token=${encodeURIComponent(rwgToken)}`;
    }
    window!.top!.location.href = url;
    window.location.href = url;
}

/**
 * 跳转新 OD 餐厅主页（正式/测试由当前构建的 API 地址决定）；同步改顶层，与 boxed/WebView 包裹一致，见 checkRoute.replaceRoute
 */
export function navigateToNewOdRestaurantPage(restaurantStringId: string): void {
    openNewOdPage(getNewOdBaseUrl('restaurant-page'), restaurantStringId);
}

/**
 * 跳转新 OD 预定页 /reservations
 */
export function navigateToNewOdReservationsPage(restaurantStringId: string): void {
    openNewOdPage(getNewOdBaseUrl('reservations'), restaurantStringId);
}